// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6533":"b37ca6c0","9369":"fd0add04"}[chunkId] + ".chunk.css";
};